import { render, staticRenderFns } from "./breakingRateWidget.vue?vue&type=template&id=751aa880&"
import script from "./breakingRateWidget.vue?vue&type=script&lang=js&"
export * from "./breakingRateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports